import { FastConditionalStrategy } from 'utility-ts-strategy';

export const PendingCourseStatusDisplayStrategy = new FastConditionalStrategy([
  [
    'Will not be reviewed',
    (status: string) => status === 'resolved_without_review'
  ],
  [
    'Does not receive credit',
    (status: string) => status === 'resolved_does_not_receive_credit'
  ],
]);



// WEBPACK FOOTER //
// ./app/lib/transfer/strategies/pending_course_status_display_strategy.ts